import React from 'react';
import { MDBDataTable } from 'mdbreact';
import dayjs from 'dayjs';
import { Badge, Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';
const columns = [
  {
    label: 'Farmer',
    field: 'farmer',
    width: 150,
  },
  {
    label: 'Expertise',
    field: 'expertise',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Advisory',
    field: 'advisory',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Status',
    field: 'status',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Created At',
    field: 'createdAt',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Started At',
    field: 'startedAt',
    sort: 'asc',
    width: 270,
  },

  {
    label: 'Completed At',
    field: 'completedAt',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Action',
    field: 'actions',
    sort: 'disabled',
    width: 100,
  },
];
const AdvisorySessionsList = (props) => {
  const history = useHistory();
  return (
    <>
      <MDBDataTable
        btn
        responsive
        bordered
        data={{
          columns: columns,
          rows: props?.sessions?.map((x) => ({
            farmer: x?.farmer?.name,
            expertise: x?.expertise?.name,
            advisory: x?.advisory?.name,
            status: x?.status,
            createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
            completedAt: dayjs(x.completedDate).format('DD/MM/YYYY'),
            startedAt: dayjs(x.startedDate).format('DD/MM/YYYY'),
            actions: (
              <>
                <Button
                  className='mr-1 mb-1 d-block'
                  size='sm'
                  disabled={x?.status === 'PENDING'}
                  color='primary'
                  onClick={() =>
                    history.push(`/advisory-session/chats/${x?.id}`)
                  }
                >
                  View Chat
                </Button>
              </>
            ),
          })),
        }}
      />
    </>
  );
};

export default AdvisorySessionsList;
